export const environment = {
  bimplus: {
    environment: 'dev' as const,
  },
  matomoTrackerUrl: 'https://awt.allplan.com/pwk/',
  matomoSiteId: '89',
  viewerBaseUrl: 'https://dev.collab.nemetschek.cloud/viewer/',
  connectApiUrl: 'https://api-dev-connect2.allplan.com/',
  connectPortalUrl: 'https://connect2-dev.allplan.com',
  consent: {
    version: '5',
    tos: '20251118',
    gtc: '20251002',
  },
  SSOConfig: {
    SSOURL: 'https://login-dev.allplan.com/realms/allplan/.well-known/openid-configuration',
    stsServer: 'https://sso.dev.auth.allplan.org/realms/allplan',
    client: 'ocp-portal-client',
  },
  enableOidcDebugLogging: 'None' as 'None' | 'Debug' | 'Warn' | 'Error',
  analyticsFlag: false,
  useCrossOriginImagesByDefault: true,
  useCrossOriginScriptsByDefault: false,
};
